<template>
  <ButtonSquare
    :title="$t('general__view__planview')"
    :imgSource="require('@/assets/icon-planview.svg')"
    size="large"
    @clicked="handleClick"
  />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { mapActions, mapState } from 'vuex'
import { MAPVIEW_PREFIX, PLANVIEW_PREFIX } from '@/store/module-prefixes'
import { setViewToPlanview } from '@/utils/views'
import { zoomToEntities } from '@/composables/useMapbox'

export default {
  name: 'PlanViewButton',
  components: {
    ButtonSquare
  },
  computed: {
    ...mapState({
      previousView: (state) => state.previousView
    }),
    ...mapState(MAPVIEW_PREFIX, {
      selectedBuilding: (state) => state.selectedBuilding
    })
  },
  methods: {
    ...mapActions(PLANVIEW_PREFIX, {
      loadSensorData: 'loadSensorData'
    }),
    async handleClick() {
      setViewToPlanview()
      await this.loadSensorData()
      await new Promise((resolve) => setTimeout(resolve, 10))
      zoomToEntities([this.selectedBuilding.id])
    }
  }
}
</script>
